import { pageKeys, IInitValues } from 'constants/search-data/search-data'
import { IParam, IInitParams } from 'constants/types/search.types'

enum Action {
  SET_PARAMETER = 'SET_PARAMETER',
  RESET_PARAMETER = 'RESET_PARAMETER',
  SET_PAGE_INFO = 'SET_PAGE_INFO',
  RESET_PAGE_INFO = 'RESET_PAGE_INFO',
  RESET_CARDS = 'RESET_CARDS',
  ADD_CARD = 'ADD_CARD',
  CHANGE_CARD = 'CHANGE_CARD',
  SET_PARAMETERS = 'SET_BOTH_PARAMETERS',
  SET_GENERAL_COUNT = 'SET_GENERAL_COUNT',
}

type UserAction =
  | { type: Action.SET_PARAMETER; selected: string; key: string; value: IParam }
  | { type: Action.RESET_PARAMETER; selected: string; payload: IInitValues }
  | { type: Action.SET_PAGE_INFO; amountPages: number; key: string; selected: string }
  | { type: Action.RESET_PAGE_INFO; selected: string; totalPages: any }
  | { type: Action.RESET_CARDS; selected: string; payload: any }
  | { type: Action.ADD_CARD; selected: string; payload: any }
  | { type: Action.CHANGE_CARD; selected: string; payload: any }
  | { type: Action.SET_PARAMETERS; selected: string; payload: IInitParams }
  | { type: Action.SET_GENERAL_COUNT; selected: string; payload: any }

const reducer = (state: IInitValues, action: UserAction) => {
  switch (action.type) {
    case Action.SET_PARAMETER: {
      const selectedParams = state.params[action.selected]
      const modifiedParam = {
        ...selectedParams,
        [action.key]: action.value,
      }
      return {
        ...state,
        params: {
          ...state.params,
          [action.selected]: modifiedParam,
        },
      }
    }
    case Action.RESET_PARAMETER:
      return {
        ...state,
        params: {
          ...state.params,
          [action.selected]: action.payload.params[action.selected],
        },
      }
    case Action.SET_PARAMETERS: {
      const selectedParams = state.params[action.selected]
      const modifiedParam = {
        ...selectedParams,
        ...action.payload,
      }
      return {
        ...state,
        params: {
          ...state.params,
          [action.selected]: modifiedParam,
        },
      }
    }
    case Action.RESET_PAGE_INFO:
      return {
        ...state,
        pages: {
          ...state.pages,
          [action.selected]: {
            [pageKeys.CURRENT]: 0,
            [pageKeys.TOTAL]: action.totalPages,
          },
        },
      }
    case Action.SET_PAGE_INFO: {
      const subSelectionPage = { ...state.pages[action.selected], [action.key]: action.amountPages }

      return {
        ...state,
        pages: {
          ...state.pages,
          [action.selected]: subSelectionPage,
        },
      }
    }
    case Action.RESET_CARDS:
      return {
        ...state,
        cards: {
          ...state.cards,
          [action.selected]: action.payload,
        },
      }

    case Action.ADD_CARD: {
      return {
        ...state,
        cards: {
          ...state.cards,
          [action.selected]: [...action.payload],
        },
      }
    }
    case Action.CHANGE_CARD:
      return {
        ...state,
        cards: {
          ...state.cards,
          [action.selected]: action.payload,
        },
      }
    case Action.SET_GENERAL_COUNT:
      return {
        ...state,
        allCount: {
          ...state.allCount,
          [action.selected]: action.payload,
        },
      }
    default:
      throw new Error()
  }
}
export { Action, reducer }
export type { UserAction }
